import { Component, OnDestroy, OnInit } from "@angular/core";
import { first } from "rxjs/operators";
import { LogClass, Logger, LogMethod } from "src/app/logger";
import { NotificationFacade } from "src/app/notifications/services/notification.facade";
import { CirculationFacade } from "src/app/services/circulation.facade";
import { SubSink } from "subsink";
import { Circulation } from "../../../interfaces";
import { NavigationService } from "../../../services/navigation.service";

@LogClass()
@Component({
    selector: "circ-form-edit",
    templateUrl: "./edit.component.html",
    styleUrls: ["./edit.component.scss"],
    standalone: false
})
export class CirculationFormEditComponent implements OnInit, OnDestroy {
  public loading = true;
  public circulation: Circulation;
  private subs = new SubSink();
  private logger: Logger;

  constructor(
    private circulationFacade: CirculationFacade,
    private navigate: NavigationService,
    private notificationFacade: NotificationFacade
  ) {}

  @LogMethod()
  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  @LogMethod()
  public onAbort(): void {
    this.navigate.back();
  }

  @LogMethod()
  public onError(error: string): void {
    this.navigate.toError(error);
  }

  @LogMethod()
  public ngOnInit(): void {
    this.circulationFacade
      .getCurrentCirculation()
      .pipe(first())
      .subscribe(
        (c) => this.setCirculation(c),
        //Is this good for errors?
        (err) => {
          this.logger.error("Error in Circulation save.", err);
          this.navigate.toError(
            "Error in Circulation load. - " + JSON.stringify(err)
          );
        }
      );
  }

  @LogMethod()
  private setCirculation(circulation: Circulation): void {
    this.circulation = circulation;
    this.loading = false;
  }

  @LogMethod()
  public onSave(value: {
    circulation: Circulation;
    navigateToOverview: boolean;
  }): void {
    this.loading = true;
    this.subs.sink = this.circulationFacade.save(value.circulation).subscribe({
      next: () => {
        if (value.navigateToOverview) {
          this.notificationFacade.success("owner.changed.save.success");
          this.navigate.toCirculationOverview();
        } else {
          this.navigate.toCirculation(value.circulation.id);
        }
      },
      error: () => {
        if (value.navigateToOverview) {
          this.notificationFacade.showError("owner.changed.save.fail");
        }
      }
    });
  }
}
